/* eslint-disable react/jsx-pascal-case */
/** @jsx jsx */
import { jsx, Styled } from 'theme-ui';
// import { useEffect } from "react"
import GlobalCSS from '../utils/global-css';
import SiteContainer from './site-container';
import Header from './header/header';
import Main from './main';
// import ContentContainer from './content-container';
import Footer from './footer';
import { SEO } from '../utils';
// import { useLocation } from "@reach/router"
// import { HomeContext } from "gatsby-theme-catalyst-core"
// import { useContext } from "react"

const GlobalLayout = ({ children }) => (
  //   const [isHome, setIsHome] = useContext(HomeContext) // eslint-disable-line
  //   const location = useLocation()
  //   const home = location.pathname === "/"
  //   useEffect(() => {
  //     if (home) {
  //       setIsHome(true)
  //     } else {
  //       setIsHome(false)
  //     }
  //   }, []) // eslint-disable-line
  <Styled.root>
    <SEO title="" />
    <GlobalCSS />
    <SiteContainer>
      <Header />
      <Main>{children}</Main>
      <Footer />
    </SiteContainer>
  </Styled.root>
);

export default GlobalLayout;
